import './PDC_form.css';
import { useState } from 'react';


function PDC_form() {
    const [numValue, setNumValue] = useState('');
    const [labelValue, setLabelValue] = useState('');


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!numValue || !labelValue) {
            console.error("Champs obligatoires");
            return;
        }
        fetch("https://api.famillerocher.fr/api_compta/add.compta.comptes.php/", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id_dc_num: numValue,
                dc_label: labelValue
            })
        })
            .then(r => r.json())
            .then(data => {
                if (data.success) {
                    console.log("Ajout OK:",data); // a changer en affichage user
                    setNumValue('');
                    setLabelValue('');
                } else {
                    console.error("Error API:", data.error);    // a changer en affichage user
                }
            })
            .catch(err => console.error("Network error:", err));
    };


    
    return (
        <form onSubmit={handleSubmit}>
            <textarea 
                placeholder='Numéro du compte'
                value={numValue}
                onChange={(e) => setNumValue(e.target.value)}
            />
            <textarea 
                placeholder='Libellé du compte'
                value={labelValue}
                onChange={(e) => setLabelValue(e.target.value)}
            />
            <button type="submit" disabled={!numValue || !labelValue}>Ajouter le compte</button>
        </form>
    );
}

export default PDC_form

